<!-- En caso de incluir Splash Screen aqui es -->
<router-outlet></router-outlet>

